import { AuthReducerAction } from '../enums';
import { AuthContextState } from '../interfaces/internal';
import { AuthReducerActions } from '../types/internal';

export const authReducer: (state: AuthContextState, action: AuthReducerActions) => AuthContextState = (
  state: AuthContextState, action: AuthReducerActions
): AuthContextState => {
  switch (action.type) {
    case AuthReducerAction.Init:
      return { ...state, ...action.payload, isAuthInitialized: true };
    case AuthReducerAction.SignIn:
      return { ...state, ...action.payload };
    case AuthReducerAction.SignOut:
      return { token: null, userData: null, appSettings: null, isAuthInitialized: true };
    case AuthReducerAction.UpdateUserInfo:
      if (state.userData) {
        return { ...state, userData: action.payload };
      }

      return state;
    case AuthReducerAction.UpdateAvatar:
      if (state.userData) {
        return { ...state, userData: { ...state.userData, avatar: action.payload.avatar } };
      }

      return state;
    case AuthReducerAction.UpdateAppSettings:
      return {
        ...state,
        appSettings: state.appSettings
          ? { ...state.appSettings, ...action.payload }
          : null,
      };
    case AuthReducerAction.UpdateAuthToken:
      return { ...state, token: action.payload };
    default:
      return state;
  }
};
